export default {
  methods: {
    // 柱状图 + 折线图
    mixBarLineRender(id, xKey, seriesData, dataList, yAxisName) {
      // x轴的值
      const xData = []
      dataList.forEach(item => {
        xData.push({
          value: item[xKey],
          textStyle: {
            fontSize: 14,
            lineHeight: 24
          }
        })
        seriesData.forEach(seriesItem => {
          seriesItem.data.push({
            value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
            xdata: item[xKey]
          })
        })
      })
      this.$nextTick(() => {
        // 定义值只显示几条柱子
        const dataZoomLg = 31
        const xAxis = this.$chart.getXAxis(xData)
        const yAxis = [
          {
            name: yAxisName || '',
            nameTextStyle: {
              fontSize: 12,
              color: '#999',
              padding: [0, 0, 10, -40]
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ]
        const option = this.$chart.mixBarLineChart(xData, yAxis, seriesData, true, {
          show: dataList.length > dataZoomLg,
          dataZoomLg: dataZoomLg,
          bottom: 30,
          zoomLock: false,
          xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
        }, {
          top: 80,
          bottom: dataList.length > dataZoomLg ? 80 : 30
        }, {
          top: 5,
          right: 0,
          itemGap: 30,
          itemHeight: 10,
          itemWidth: 10
        }, xAxis, 1)
        // 图形销毁重新绘制
        document.getElementById(id).removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
      })
    },
    // 饼状图
    pieRender(id, sumKey = 'sum', seriesData, dataList) {
      const newObj = dataList.reduce((obj, item) => {
        obj.sum += item[sumKey] * 1
        obj.pieColor.push(item.color)
        return obj
      }, {
        sum: 0,
        pieColor: []
      })
      this.isNodata = !newObj.sum
      const pieColor = newObj.pieColor
      const sum = newObj.sum
      seriesData[0].data = dataList.map(item => {
        return {
          value: Math.round(item[sumKey] / sum * 100),
          name: item.name,
          unit: '%'
        }
      })
      // 获取DVT wells评估
      this.$nextTick(() => {
        const option = this.$chart.pieChart(seriesData, pieColor, false)
        // 图形销毁重新绘制
        document.getElementById(id).removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
      })
    },
    // 柱状图绘制
    barRender(id, xKey, seriesData, dataList, yAxisName, yAxisPdLeft) {
      // x轴的值
      const xData = []
      dataList.forEach(item => {
        xData.push({
          value: item[xKey] || '',
          textStyle: {
            fontSize: 14,
            lineHeight: 24
          }
        })
        seriesData.forEach(seriesItem => {
          seriesItem.data.push({
            value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
            xdata: item[xKey]
          })
        })
      })
      this.$nextTick(() => {
        const xAxis = this.$chart.getXAxis(xData)
        const yAxis = [
          {
            name: yAxisName || '',
            nameTextStyle: {
              fontSize: 12,
              color: '#999',
              padding: [0, 0, 10, yAxisPdLeft || -20]
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ]
        // 定义值只显示几条柱子
        const dataZoomLg = 24
        const option = this.$chart.barChart(xData, yAxis, seriesData, true, {
          show: dataList.length > dataZoomLg,
          dataZoomLg: dataZoomLg,
          bottom: 30,
          zoomLock: false,
          xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
        }, {
          top: 80,
          left: 20,
          right: 20,
          bottom: dataList.length > dataZoomLg ? 80 : 30
        }, {
          top: 5,
          right: 0,
          itemGap: 30,
          itemHeight: 10,
          itemWidth: 10
        }, xAxis)
        // 图形销毁重新绘制
        document.getElementById(id).removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
      })
    },
    // 柱状图绘制
    columnRender(id, xKey, seriesData, dataList, yAxisName, yAxisPdLeft) {
      // x轴的值
      const xData = seriesData.map(item => {
        return {
          value: item[xKey] || '',
          textStyle: {
            fontSize: 14,
            lineHeight: 24
          }
        }
      })
      dataList.forEach(item => {
        seriesData.forEach(seriesItem => {
          seriesItem.data.push({
            value: item[seriesItem.key] ? item[seriesItem.key] * 1 : 0,
            xdata: item[xKey]
          })
        })
      })
      this.$nextTick(() => {
        const xAxis = this.$chart.getXAxis(xData)
        const yAxis = [
          {
            name: yAxisName || '',
            nameTextStyle: {
              fontSize: 12,
              color: '#999',
              padding: [0, 0, 10, yAxisPdLeft || -20]
            },
            axisLabel: {
              formatter: '{value}'
            }
          }
        ]
        // 定义值只显示几条柱子
        const dataZoomLg = 24
        const option = this.$chart.columnChart(xData, yAxis, seriesData, true, {
          show: dataList.length > dataZoomLg,
          dataZoomLg: dataZoomLg,
          bottom: 30,
          zoomLock: false,
          xAxisIndex: xAxis.length > 1 ? [0, 1] : [0]
        }, {
          top: 80,
          left: 20,
          right: 20,
          bottom: dataList.length > dataZoomLg ? 80 : 30
        }, {
          top: 5,
          right: 0,
          itemGap: 30,
          itemHeight: 10,
          itemWidth: 10
        }, xAxis)
        // 图形销毁重新绘制
        document.getElementById(id).removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById(id))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
      })
    }
  }
}
